module.exports = __webpack_public_path__ + "img/features-hud-object-editor.87495d7a.png";